module.exports = __webpack_public_path__ + "img/cons_3.73c68c5c.jpg";